exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#clinic-show-custom-schedule .modal-dialog{max-width:768px}#clinic-show-custom-schedule .wabident-small{padding:12px 10px;max-width:75px}#clinic-show-custom-schedule .clinic-schedule__hours{flex-flow:row nowrap}", ""]);

// exports
